import styled from "styled-components";
import { Link } from "react-router-dom";
import { ate } from "../global/breakpoints";

/*
 * A TRILHA "Relatórios > Contas > Ordens".
 *
 * Era `flex-direction: row` sem quebra, com fonte de 30. Em 375 de largura os
 * três níveis somam mais que a tela e o último saía cortado pela borda
 * ("Ord..."), levando junto a rolagem horizontal da página.
 */
export const BreadcrumbContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--sp-10);
  margin-bottom: var(--sp-12);
`;
export const BreadcrumbItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center; // Isso alinhará o conteúdo ao centro
  &:after {
    content: ">";
    margin-left: var(--sp-10);
    font-size: var(--fs-lg);
    color: ${(props) => props.theme.textPrimary};
  }
  &:last-child:after {
    content: "";
  }
`;

export const BreadCrumbIcon = styled.div<{ selected?: boolean; color: string }>`
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  padding: 0 var(--sp-2);
  font-size: var(--fs-2xl);

  ${ate.tablet} {
    font-size: var(--fs-lg);
  }
  color: ${(props) => props.theme.colors.selection};
  text-shadow: -0.2px -0.2px 0 #000, 0.2px -0.2px 0 #000, -0.2px 0.2px 0 #000,
    0.5px 0.5px 0 #000;
`;

export const StyledLink = styled(Link)<{ selected?: boolean }>`
  color: ${(props) => props.theme.colors.selection};
  text-shadow: -0.2px -0.2px 0 #000, 0.2px -0.2px 0 #000, -0.2px 0.2px 0 #000,
    0.5px 0.5px 0 #000;
  text-decoration: none;
  font-family: "Roboto";
  font-size: var(--fs-2xl);
  font-weight: bold;

  ${ate.tablet} {
    font-size: var(--fs-lg);
  }
`;
